module.exports = __webpack_public_path__ + "static/media/delete.36724944.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/delete.svg
// module id = 105
// module chunks = 0